import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { INDIA_COUNTRY_CODE } from './types';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { isValidForm } from './isValidUpiForm';
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
import { createMOP, updateBillingAddress, updateFormFieldData } from '../../redux/PaymentState/PaymentState.actions';
import { saveUserAddressCommands } from '../../redux/CommandState/CommandState.actions';
import { UserAddressCommandNames } from '@chegg/commerce-utils';
import { PAYMENT_PROCESSOR_TYPE } from '@chegg/checkout-sdk';

/**
 * This function will validate the form and start cascade of create MoP & Initial checkout
 * @param dispatch
 * @param payload — with the UPI form field payload
 * @param setField callback to set the field error values
 */
export function submitUpiForm(_ref) {
  var dispatch = _ref.dispatch,
    payload = _ref.payload,
    payment = _ref.payment,
    setField = _ref.setField;
  dispatch(saveUserAddressCommands([{
    commandName: UserAddressCommandNames.VERIFY_ADDRESS
  }]));
  dispatch(saveConfigs({
    submit: false
  }));
  dispatch(saveConfigs({
    ui: {
      showUpiProcessing: true
    }
  }));
  var fields = _objectSpread(_objectSpread({}, payload), {}, {
    pincode: {
      value: payment.billingAddress.zip,
      error: payment.formFields.userAddress.error ? false : true
    },
    country: {
      value: payment.billingAddress.country,
      error: payment.formFields.userAddress.error ? false : true
    }
  });
  var formValid = isValidForm(fields, setField);
  if (!formValid) {
    dispatch(saveConfigs({
      ui: {
        showUpiProcessing: false
      }
    }));
    return;
  }
  var _ref2 = fields,
    name = _ref2.name,
    pincode = _ref2.pincode,
    country = _ref2.country;
  dispatch(updateBillingAddress({
    fname: name.value,
    zip: pincode.value,
    country: INDIA_COUNTRY_CODE
  }));
  dispatch(updateFormFieldData({
    fields: fields
  }));
  dispatch(createMOP({
    accountType: ACCOUNT_TYPE.UPI,
    paymentProcessor: PAYMENT_PROCESSOR_TYPE.BILLDESK,
    name: name.value,
    billing: _objectSpread(_objectSpread({}, payment.billingAddress), {}, {
      country: INDIA_COUNTRY_CODE,
      // should this be hardcoded?
      zip: pincode.value
    }),
    details: {
      firstName: name.value,
      lastName: name.value,
      billingAddress: _objectSpread(_objectSpread({}, payment.billingAddress), {}, {
        city: '',
        line1: '',
        line2: '',
        state: '',
        postalCode: pincode.value || '',
        countryCode: country.value || ''
      })
    },
    nonce: '',
    deviceData: payment.deviceData
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/submitForm.js
// module id = 4592
// module chunks = 11